
        export const version = '6.3.0';
        export const buildTimestampIso = '2022-10-19T20:35:19.183Z';
        export const versionCheck = '6.3.0,2022-10-19T20:35:18.593Z';
        export const curEnv = 'soundbites-devtest';
        export const hash = 'fcb631074';
        export const commit = "[sb] Setup soundbite.devtest deployment";
        export const commitTimestampIso = '2022-10-19T13:29:55-07:00';
        